import { IoIosClose } from 'react-icons/io';

import { useEventHistory } from '../../hooks';

import { useNavigate, useParams } from 'react-router-dom';
import { Box, Icon, IconButton, Text } from '@chakra-ui/react';
import { IoAlertCircleOutline, IoChevronBack } from 'react-icons/io5';

import { CheckoutHeaderTabs } from './components/CheckoutHeaderTabs';
import { useGetCheckoutRoutesVerification } from '../../hooks/useGetCheckoutRoutesVerification';
import { useEventContext } from '../../provider';

export const CheckoutHeader = () => {
  const navigate = useNavigate();

  const { eventID } = useParams();
  const { invalidFieldsNames } = useEventContext();

  const amountOfErrors = invalidFieldsNames.length;
  const hasAnyError = amountOfErrors > 0;

  const {
    isPixRoute,
    isAddCardRoute,
    isPaymentMethodsRoute,
    isConfirmCardRoute,
    isCardRoute,
    isPaymentRoute,
  } = useGetCheckoutRoutesVerification();

  const eventHistory = useEventHistory();

  const onClose = () => {
    if (isCardRoute) {
      navigate(-1);
    } else {
      eventHistory.replace(`/event/${eventID}`);
    }
  };

  const hasPaymentRoutesInputsErrors = hasAnyError && isPaymentRoute;

  return (
    <Box
      as="header"
      css={{
        '::-webkit-scrollbar ': {
          display: 'none',
        },
      }}
      minHeight="50px"
      display="flex"
      overflowX="auto"
      maxW="640px"
      w="full"
      mt={hasPaymentRoutesInputsErrors ? { base: '0', md: '2' } : '0'}
      bgColor={hasPaymentRoutesInputsErrors ? 'red.100' : 'white'}
      roundedBottom={hasPaymentRoutesInputsErrors ? 'md' : 'unset'}
      roundedTop={hasPaymentRoutesInputsErrors ? 'md' : 'unset'}
      // px={{ base: 5, md: 0 }}
      // alignItems="center"
      mx="auto">
      {!isCardRoute && !isPixRoute && !hasPaymentRoutesInputsErrors && (
        <CheckoutHeaderTabs />
      )}
      {hasPaymentRoutesInputsErrors && (
        <Box display="flex" alignItems="center" pl="5">
          <Icon as={IoAlertCircleOutline} boxSize="7" color="red.500" />
          <Text color="black" ml="4" fontSize="sm" fontWeight="bold">
            Verifique {amountOfErrors}{' '}
            {amountOfErrors === 1 ? 'campo destacado' : 'campos destacados'}
          </Text>
        </Box>
      )}

      {isCardRoute && (
        <Box display="flex" alignItems="center" my="1">
          <IconButton
            icon={<Icon as={IoChevronBack} boxSize="7" aria-hidden={true} />}
            variant="outline"
            color="black"
            border="none"
            aria-label="Voltar para tela de pagamento"
            onClick={() => navigate(-1)}
          />

          <Text ml="1" as="h1" fontSize={['xl', 'xl', '3xl', '3xl']}>
            {isPaymentMethodsRoute && 'Formas de Pagamento'}
            {isAddCardRoute && 'Adicionar cartão'}
            {isConfirmCardRoute && 'Qual foi o valor no seu cartão?'}
          </Text>
        </Box>
      )}

      <IconButton
        icon={<Icon as={IoIosClose} boxSize="10" color="black" />}
        onClick={onClose}
        aria-label="close"
        cursor="pointer"
        zIndex="99"
        ml="auto"
        variant="outline"
        border="none"
        _hover={
          hasPaymentRoutesInputsErrors
            ? { backgroundColor: 'red.200' }
            : { backgroundColor: 'gray.50' }
        }
        my="1"
        mr="4"
      />
    </Box>
  );
};
